var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"item",class:{ 'item--danger': _vm.isDanger },attrs:{"type":"button","disabled":_vm.disabled},on:{"click":_vm.emitClick}},[_vm._t("icon"),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }